module.exports = __webpack_public_path__ + "img/appltCourse-img38.fc0f8367.png";